module.exports = __webpack_public_path__ + "static/media/project-img3.af13ef03.png";